package com.example.mystybag.core.helpers

import com.example.mystybag.commonData.expected.isInRelease
import com.example.mystybag.core.expected.LogHelper
import com.example.mystybag.core.expected.logException
import com.example.mystybag.core.extensions.ifNullOrEmpty
import com.example.mystybag.core.logic.base.UnhandledCommonCodeException
import com.example.mystybag.remoteLogger.RemoteLogger
import kotlinx.coroutines.CoroutineExceptionHandler
import kotlinx.coroutines.CoroutineName
import kotlin.coroutines.cancellation.CancellationException

object Logger {

    fun log(message: String) {
        if (!isInRelease())
            println(message)

        RemoteLogger.log(message, RemoteLogger.TYPE_LOG)
    }
}

val globalExceptionHandler = CoroutineExceptionHandler { ctx, throwable ->
    if (throwable !is CancellationException) {
        val name = ctx[CoroutineName]?.name.ifNullOrEmpty { "Unknown" }
        if (throwable is Exception)
            logException(UnhandledCommonCodeException(throwable.message?.plus(" [$name]") ?: name, throwable))
        else if (throwable is Error)
            logException(UnhandledCommonCodeException(throwable.message?.plus(" [$name]") ?: "Unhandled shared error [$name]", throwable))

        LogHelper.logEvent("Uncaught Exception in [$name] -> ${throwable.message} -> ${throwable.stackTraceToString().take(200)}")
        throw UnhandledCommonCodeException("Unhandled exception caught in common code coroutine [$name]", throwable)
    }
}